import { render, staticRenderFns } from "./EmailsUnitiesConfigs.vue?vue&type=template&id=b64dafb6&"
import script from "./EmailsUnitiesConfigs.vue?vue&type=script&lang=js&"
export * from "./EmailsUnitiesConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports